import { useEffect, useState } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { IBranch } from "./BranchListController";
import { fetchBranchId, IBranchForm } from "./BranchFormController";
import Loader from "../../core-component/ui/Loader";
import { FormRightModalWrapper } from "../../core-component/ui";
import MaskedValue from "../../core-component/ui/ICMaskedValue";
import { ICSwitch } from "../../core-component/form";

interface IBranchFormProps {
  handleClose: (status: boolean) => void;
  branchToView: IBranch;
}

const BranchForm: React.FC<IBranchFormProps> = ({
  handleClose,
  branchToView,
}) => {
  const { t } = UseTranslationHook();
  const [loading, setLoading] = useState(false);
  const [branchFormInitialValues, setBranchFormInitialValues] =
    useState<IBranchForm>();

  useEffect(() => {
    getBranchById(branchToView.id);
  }, []);

  const getBranchById = async (id: string) => {
    setLoading(true);
    await fetchBranchId(id, handleClose, setBranchFormInitialValues);
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {branchFormInitialValues && (
            <FormRightModalWrapper
              containerClassName="!w-1/3"
              onClose={() => handleClose(false)}
              title={t("branch")}
              footer={{
                created_date: branchFormInitialValues.created_date,
                modified_date: branchFormInitialValues.modified_date,
                created_by: branchFormInitialValues.created_by,
                modified_by: branchFormInitialValues.modified_by,
              }}
            >
              <div className="p-4 bg-base rounded-md">
                <div className="border-b pb-1">
                  <div className="text-sm text-muted">{t("branch_name")}</div>
                  <div>{branchFormInitialValues.branch_name}</div>
                </div>
                <div className="mt-4 border-b pb-1">
                  <div className="text-sm text-muted">
                    {t("contact_person_name")}
                  </div>
                  <div>{branchFormInitialValues.contact_person_name}</div>
                </div>
                <div className="mt-4 border-b pb-1">
                  <div className="text-sm text-muted">
                    {t("contact_person_mobile")}
                  </div>
                  <div>
                    <MaskedValue
                      value={branchFormInitialValues.contact_person_mobile}
                      regex={/(\d{5})$/}
                    />
                  </div>
                </div>
                {branchFormInitialValues.contact_person_email && (
                  <div className="mt-4 border-b pb-1">
                    <div className="text-sm text-muted">
                      {t("contact_person_email")}
                    </div>

                    <div>
                      <MaskedValue
                        value={branchFormInitialValues.contact_person_email}
                        regex={/(?<=.).(?=[^@]*?@)|(?:@)([^@]{2})(?=.*\.)/gm}
                      />
                    </div>
                  </div>
                )}
                <div className="mt-4 border-b pb-1">
                  <div className="text-sm text-muted">{t("firm_name")}</div>
                  <div>{branchFormInitialValues.firm_name}</div>
                </div>
                <div className="mt-4 border-b pb-2">
                  <div className="text-sm text-muted">{t("status")}</div>
                  <ICSwitch
                    containerClassName="!cursor-default mt-1"
                    checked
                    onChange={() => {}}
                    disabled
                  />
                </div>
                {branchFormInitialValues.address && (
                  <div className="mt-4 border-b pb-1">
                    <div className="text-sm text-muted">{t("address")}</div>
                    <div>
                      {branchFormInitialValues.address.address_line1},&nbsp;
                      {branchFormInitialValues.address.address_line2},&nbsp;
                      {branchFormInitialValues.address?.address_line3 &&
                        branchFormInitialValues.address?.address_line3 + ","}
                    </div>
                    <div>
                      {branchFormInitialValues.address.city},&nbsp;
                      {branchFormInitialValues.address.zip_code},&nbsp;
                      {branchFormInitialValues.address.state_name},&nbsp;
                      {branchFormInitialValues.address.country_name}
                    </div>
                  </div>
                )}
              </div>
            </FormRightModalWrapper>
          )}
        </>
      )}
    </>
  );
};
export default BranchForm;
